import { Accordion } from 'react-bootstrap'
import { AccordionItemContainer } from './style'

function AccordionItem({
  onClick = () => {},
  className = '',
  eventKey = '',
  selectedToggle,
  setSelectedToggle,
  renderToggle = () => {},
  renderWhenExpanded = () => {},
}) {
  return (
    <AccordionItemContainer className={className}>
      <Accordion.Toggle
        variant="link"
        as={'div'}
        className="custom-accordion-toggler"
        eventKey={eventKey}
        onClick={() => {
          if (selectedToggle !== eventKey) {
            setSelectedToggle(eventKey)
          } else {
            setSelectedToggle('')
          }
          onClick()
        }}
      >
        {renderToggle()}
      </Accordion.Toggle>
      <Accordion.Collapse
        className={selectedToggle[`${eventKey}`]}
        eventKey={eventKey}
      >
        {renderWhenExpanded()}
      </Accordion.Collapse>
    </AccordionItemContainer>
  )
}

export default AccordionItem
